import { render } from "./TECMSimuladosLanding.vue?vue&type=template&id=c4100198&scoped=true"
import script from "./TECMSimuladosLanding.vue?vue&type=script&lang=js"
export * from "./TECMSimuladosLanding.vue?vue&type=script&lang=js"

import "./TECMSimuladosLanding.vue?vue&type=style&index=0&id=c4100198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4100198"]])

export default __exports__